/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Li } from '@blend/enterprise-components';
const styles = StyleSheet.create({
  headerBar: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  spacer: {
    display: 'inline-block',
    marginBottom: 8,
    marginLeft: 16,
  },
});

const listStyle: Partial<Li.Props> = {
  bulletColor: 'SKY',
  bulletSize: 20,
  centerAligned: false,
};

export namespace InstructionBullet {
  export interface Props {}
}

export const InstructionBullet: React.FC<InstructionBullet.Props> = ({ children }) => {
  return (
    <Li {...listStyle}>
      <div className={css(styles.spacer)}>{children}</div>
    </Li>
  );
};
